import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService, productDisplayName } from '@kservice';

@Component({
  selector: 'kp-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
})
export class LandingHeaderComponent {
  constructor(public themeService: ThemeService) {}

  @Input() isLoading = false;
  @Output() getStartedClicked = new EventEmitter<string>();

  productName = productDisplayName;
}
